// realtime.ts

import { ENV } from './ENV';

const REALTIME_CLOUD_HOST = ENV.REALTIME_CLOUD_HOST;

/**
 * Canonical cloud WebSocket URL for trainer dashboards.
 * Tablets and dashboards both connect to this gateway path.
 */
export const REALTIME_GATEWAY_URL = ENV.REALTIME_GATEWAY_URL;

/**
 * Helper to detect whether a URL points at the realtime gateway. We compare host
 * and path rather than scheme so ws/wss both qualify.
 */
export function isCloudUrl(url?: string | null): boolean {
  if (!url) return false;
  try {
    const parsed = new URL(url, 'http://dummy');
    return (
      parsed.host === REALTIME_CLOUD_HOST &&
      parsed.pathname.startsWith('/client')
    );
  } catch {
    return url.includes(REALTIME_CLOUD_HOST);
  }
}
